import classNames from 'classnames';
import { JSX } from 'react';

interface IRenderRichTextProps {
  body?: string;
  className?: string;
  useProse?: boolean;
}

export const RenderRichText = ({
  body,
  className,
  useProse = true,
}: IRenderRichTextProps): JSX.Element => {
  if (!body) {
    return <></>;
  }
  return (
    <span
      className={classNames(
        useProse && 'prose prose-a:font-[700] prose-a:no-underline',
        className,
      )}
      data-testid="rich-text"
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
};
